<div class="row">
    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div *ngIf="!institutionLoaded">
            <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                'height.px': 80,
                'width.px': 180
            }"></ngx-skeleton-loader>
        </div>

        <div class="d-flex justify-content-center justify-content-sm-center justify-content-md-start"
            *ngIf="institutionLoaded">
            <a routerLink="/courses">
                <img loading="lazy" [src]="institution?.logo" height="50"
                    alt="{{ institution?.title }}" title="{{ institution?.title }}" />
            </a>
        </div>

        <div *ngIf="!institutionLoaded">
            <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                'height.px': 40
            }"></ngx-skeleton-loader>

            <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                'height.px': 40,
                'width.px': 150
            }"></ngx-skeleton-loader>
        </div>

        <h1 class="font-weight-bold mt-5 text-center text-sm-center text-md-left" style="font-size: 2.125rem;"
            *ngIf="institutionLoaded">{{
            institution?.title }}</h1>

        <div *ngIf="!institutionLoaded">
            <ngx-skeleton-loader count="2" appearance="circle" animation="pulse"></ngx-skeleton-loader>
        </div>

        <div *ngIf="institutionLoaded"
            class="row d-flex justify-content-center justify-content-sm-center justify-content-md-start"
                style="margin-top: 35px;">
            <div class="col-auto">
                <div class="rounded-pill rounded-pill-counter pl-5 pr-5 py-2 d-inline-flex">
                    <p class="mb-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18.435" height="18.483" viewBox="0 0 18.435 18.483">
                            <path id="finance_mode_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24" d="M124.851-868.7v-7.422h2.911v7.422l-1.455-1.358Zm4.851,1.455V-880h2.911v9.848Zm-9.7,3.347v-8.344h2.911v5.433Zm0,2.377,6.258-6.258,3.444,2.959,5.433-5.433h-1.552v-1.94h4.851v4.851h-1.94v-1.552L129.8-862.2l-3.444-2.959-3.638,3.638Z" transform="translate(-120 880)" [attr.fill]="institution?.bg_color" />
                        </svg>
                        <span class="pl-3">{{ levels }}</span>
                    </p>
                </div>
                <p class="d-inline-flex ml-3 text-muted">Levels</p>
            </div>
            <div class="col-auto">
                <div class="rounded-pill rounded-pill-counter pl-5 pr-5 py-2 d-inline-flex">
                    <p class="mb-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20.624" height="16.499" viewBox="0 0 20.624 16.499">
                            <path id="folder_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24" d="M82.062-783.5a1.986,1.986,0,0,1-1.457-.606A1.986,1.986,0,0,1,80-785.563v-12.374a1.986,1.986,0,0,1,.606-1.457A1.986,1.986,0,0,1,82.062-800h6.187l2.062,2.062h8.249a1.986,1.986,0,0,1,1.457.606,1.986,1.986,0,0,1,.606,1.457v10.312a1.986,1.986,0,0,1-.606,1.457,1.986,1.986,0,0,1-1.457.606Zm0-2.062h16.5v-10.312h-9.1L87.4-797.938H82.062Zm0,0v0Z" transform="translate(-80 800)" [attr.fill]="institution?.bg_color"/>
                        </svg>
                        <span class="pl-3">{{ subjects }}</span>
                    </p>
                </div>
                <p class="d-inline-flex ml-3 text-muted">Subjects</p>
            </div>
        </div>

        <div *ngIf="!institutionLoaded">
            <ngx-skeleton-loader count="2" animation="pulse"></ngx-skeleton-loader>
        </div>

        <p class="syllabus-introduction-description" *ngIf="institutionLoaded" [innerHTML]="institution?.description | safeHtml">
        </p>

        <div class="row mb-10">
            <div class="col-12">
                <div class="container p-0">
                    <div class="row">
                        <div class="col-12 mb-3 mob-inst-btns" *ngIf="institutionLoaded">
                            <a routerLink="/courses/{{ institution?.slug }}/{{ firstLevelSlug }}"><button type="button"
                                    class="px-10 d-block d-sm-block d-md-block d-lg-inline-flex d-xl-inline-flex btn btn-primary rounded-pill btn-lg font-size-16 font-weight-bold py-4 mob-inst-btns-af">View
                                    Subjects &amp; Fees</button></a>
                            <a routerLink="/timetable/{{ id }}">
                                <button type="button"
                                    class="px-10 btn btn-outline-primary btn-lg rounded-pill font-size-16
                                        font-weight-bold py-4 ml-3 d-inline-flex d-lg-inline-flex d-xl-inline-flex
                                        align-items-center justify-content-center mob-inst-btns-as">
                                    <!--<i class="far fa-calendar-minus text-primary"></i>-->
                                    <mat-icon class="d-inline-block font-size-22 mr-2"
                                        aria-hidden="false" aria-label="View Timetable">date_range</mat-icon>
                                    <span class="d-inline-block">View Timetable</span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-end" *ngIf="institutionLoaded">
        <!--<div class="mt-10 img-intro" *ngIf="institution?.background_image">-->
            <!--<div class="d-none background-square rounded shadow" [style.background]="institution.bg_color"></div>-->
            <img loading="lazy" [src]="institution?.background_image" [alt]="institution?.alt" class="_mt-10 img-fluid _shadow rounded" />
        <!--</div>-->
    </div>
</div>